import React from 'react';
import ChangeWithdrawalPlanBankInfo from 'widgets/ChangeWithdrawal/ChangeWithdrawalPlanBankInfo';

const ChangeWithdrawalPlanBankInfoPage = ({ datasource }: {datasource: any}) => <ChangeWithdrawalPlanBankInfo datasource={datasource} />;

export default ChangeWithdrawalPlanBankInfoPage;
